export const mainUrl = "https://backend.egy-courses.com";